import { CLEAR_ALL, LOGOUT } from '../../../../store/Types';

export const ALL_PLAN_EVALUACION = 'ALL_PLAN_EVALUACION';
export const LOADING_ALL_PLAN_EVALUACION = 'LOADING_ALL_PLAN_EVALUACION';
export const ACTIVO_PLAN_EVALUACION = 'ACTIVO_PLAN_EVALUACION';
export const LOADING_UPDATE_ESTATUS_PLAN_EVALUACION =
  'LOADING_UPDATE_ESTATUS_PLAN_EVALUACION';
export const PARAMS_PLAN_EVALUACION = 'PARAMS_PLAN_EVALUACION';
export const DETALLES_PLAN_EVALUACION = 'DETALLES_PLAN_EVALUACION';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  loadingUpdateEstatus: false,
  params: {},
  detalles: {
    deleteTema: false,
    deleteEvaluacion: false,
    deleteActividad: false,
  },
};

export const planEvaluacionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_PLAN_EVALUACION:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_PLAN_EVALUACION:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_PLAN_EVALUACION:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case DETALLES_PLAN_EVALUACION:
      return {
        ...state,
        detalles: action.payload,
      };
    case LOADING_UPDATE_ESTATUS_PLAN_EVALUACION:
      return {
        ...state,
        loadingUpdateEstatus: action.payload,
      };
    case PARAMS_PLAN_EVALUACION:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
